import React, { useContext, useState, useEffect } from "react";
import { TranslatorContext } from "../../context/Translator.js";
import { Link } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Nav, Tab, Spinner } from "react-bootstrap";
import { FloatCardComponent } from "../../components/cards/index.js";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent.js";
import { PaginationComponent } from "../../components/index.js";
import PageLayout from "../../layouts/PageLayout.js";
import { obtenerTransferencias, aprobarTransferencia, rechazarTransferencia } from "../../api/transferencias.api.ts";
import TransferenciaAprobacionModalComponent from "../../components/modals/TransferenciaAprobacionModalComponent.js";
import TransferenciaDetalleModalComponent from "../../components/modals/TransferenciaDetalleModalComponent.js";
import Swal from 'sweetalert2';
import { AnchorComponent, ButtonComponent } from "../../components/elements/index.js";
import { useAuthStore } from "../../store/auth.store.ts";

export default function TransfererenciasListPage() {

    const { t, n } = useContext(TranslatorContext);
    const { usuario } = useAuthStore((state) => state);

    const [loading, setLoading] = useState(true);
    const [transferenciasPendientes, setTransferenciasPendientes] = useState([]);
    const [transferenciasAprobadas, setTransferenciasAprobadas] = useState([]);
    const [transferenciasRechazadas, setTransferenciasRechazadas] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [transferenciaSeleccionada, setTransferenciaSeleccionada] = useState(null);
    const [showDetalleModal, setShowDetalleModal] = useState(false);
    const [transferenciaDetalle, setTransferenciaDetalle] = useState(null);
    const [tipoDetalle, setTipoDetalle] = useState('aprobada');

    // Cargar datos al montar
    useEffect(() => {
        cargarTransferencias();
    }, []);

    const cargarTransferencias = async () => {
        setLoading(true);
        try {
            // Obtener transferencias por estado
            const respPendientes = await obtenerTransferencias('en_verificacion');
            const respAprobadas = await obtenerTransferencias('aprobada');
            const respRechazadas = await obtenerTransferencias('rechazada');

            setTransferenciasPendientes(respPendientes.data || []);
            setTransferenciasAprobadas(respAprobadas.data || []);
            setTransferenciasRechazadas(respRechazadas.data || []);
        } catch (error) {
            console.error('Error al cargar transferencias:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las transferencias'
            });
        } finally {
            setLoading(false);
        }
    };

    const handleAbrirModal = (transferencia) => {
        console.log('Transferencia seleccionada:', transferencia);
        setTransferenciaSeleccionada(transferencia);
        setShowModal(true);
    };

    const handleAbrirDetalleModal = (transferencia, tipo) => {
        setTransferenciaDetalle(transferencia);
        setTipoDetalle(tipo);
        setShowDetalleModal(true);
    };

    const handleAprobar = async (id, comentario) => {
        try {
            const resultado = await aprobarTransferencia(id, comentario);
            if (!resultado.error) {
                await cargarTransferencias();
                return { error: false };
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: resultado.msg || 'Error al aprobar la transferencia'
                });
                return { error: true };
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al procesar la aprobación'
            });
            return { error: true };
        }
    };

    const handleRechazar = async (id, comentario) => {
        try {
            const resultado = await rechazarTransferencia(id, comentario);
            if (!resultado.error) {
                await cargarTransferencias();
                return { error: false };
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: resultado.msg || 'Error al rechazar la transferencia'
                });
                return { error: true };
            }
        } catch (error) {
            console.error('Error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al procesar el rechazo'
            });
            return { error: true };
        }
    };

    const renderTabla = (transferencias, mostrarAcciones = true, tipoAccion = 'pendiente') => {
        if (loading) {
            return (
                <div className="text-center p-4">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Cargando...</span>
                    </Spinner>
                </div>
            );
        }

        if (transferencias.length === 0) {
            return (
                <div className="alert alert-info">
                    No hay transferencias en este estado
                </div>
            );
        }

        return (
            <div className="mc-table-responsive">
                <table className="mc-table product">
                    <thead className="mc-table-head primary">
                        <tr>
                            <th>Código</th>
                            <th>Alumno</th>
                            <th>Gira</th>
                            <th>Monto</th>
                            <th>Multa</th>
                            <th>Referencia Pago</th>
                            <th>Fecha Pago</th>
                            
                            {mostrarAcciones && <th>Acciones</th>}
                        </tr>
                    </thead>
                    <tbody className="mc-table-body even">
                        {transferencias.map((item, index) => (
                            <tr key={index}>
                                <td>
                                    <code>{item.trn_codigo}</code>
                                </td>
                                <td>{`${item.alu_nombres || ''} ${item.alu_apellidos || ''}`.trim() || 'N/A'}</td>
                                <td>{item.gir_id || 'N/A'}</td>
                                <td> ${Number(item.trn_monto).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</td>
                                <td>
                                    {item.trn_multa > 0 ? (
                                        <span style={{ color: '#dc3545', fontWeight: 'bold' }}>
                                         ${Number(item.trn_multa).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}  
                                        </span>
                                    ) : (
                                        <span>-</span>
                                    )}
                                </td>
                                <td>{item.trn_referencia_pago || '-'}</td>
                                <td>
                                    {item.trn_fecha_pago
                                        ? new Date(item.trn_fecha_pago).toLocaleDateString('es-CL')
                                        : '-'}
                                </td>
                                
                                {mostrarAcciones && (
                                    <td>
                                        <div className="mc-table-action">
                                            {tipoAccion === 'pendiente' ? (
                                                <Button
                                                    size="sm"
                                                    variant="primary"
                                                    onClick={() => handleAbrirModal(item)}
                                                    title="Gestionar"
                                                >
                                                    <i className='material-icons'>edit</i>
                                                </Button>
                                            ) : (
                                                <Button
                                                    size="sm"
                                                    variant={tipoAccion === 'aprobada' ? 'success' : 'danger'}
                                                    onClick={() => handleAbrirDetalleModal(item, tipoAccion)}
                                                    title={`Ver detalle de ${tipoAccion === 'aprobada' ? 'aprobación' : 'rechazo'}`}
                                                >
                                                    <i className='material-icons'>visibility</i>
                                                </Button>
                                            )}
                                        </div>
                                    </td>
                                )}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };


    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">Gestión de Transferencias</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">Administración</Link></li>
                                <li className="mc-breadcrumb-item">Transferencias</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                
                <Col xl={12}>
                    <div className="mc-card">
                        <Tab.Container defaultActiveKey="pendientes">
                            <Nav variant="tabs" className="mb-4">
                                <Nav.Item>
                                    <Nav.Link eventKey="pendientes" className="fw-bold">
                                        <i className='material-icons' style={{ marginRight: '0.5rem' }}>schedule</i>
                                        Pendientes de Revisión
                                        {transferenciasPendientes.length > 0 && (
                                            <span 
                                                className="badge bg-warning ms-2"
                                                style={{ color: '#000' }}
                                            >
                                                {transferenciasPendientes.length}
                                            </span>
                                        )}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="aprobadas" className="fw-bold">
                                        <i className='material-icons' style={{ marginRight: '0.5rem' }}>check_circle</i>
                                        Aprobadas
                                        {transferenciasAprobadas.length > 0 && (
                                            <span 
                                                className="badge bg-success ms-2"
                                            >
                                                {transferenciasAprobadas.length}
                                            </span>
                                        )}
                                    </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="rechazadas" className="fw-bold">
                                        <i className='material-icons' style={{ marginRight: '0.5rem' }}>cancel</i>
                                        Rechazadas
                                        {transferenciasRechazadas.length > 0 && (
                                            <span 
                                                className="badge bg-danger ms-2"
                                            >
                                                {transferenciasRechazadas.length}
                                            </span>
                                        )}
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Tab.Content>
                                <Tab.Pane eventKey="pendientes">
                                    <div className="mb-3">
                                        <h5>Transferencias Pendientes de Revisión</h5>
                                        {renderTabla(transferenciasPendientes, true)}
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="aprobadas">
                                    <div className="mb-3">
                                        <h5>Transferencias Aprobadas</h5>
                                        {renderTabla(transferenciasAprobadas, true, 'aprobada')}
                                    </div>
                                </Tab.Pane>

                                <Tab.Pane eventKey="rechazadas">
                                    <div className="mb-3">
                                        <h5>Transferencias Rechazadas</h5>
                                        {renderTabla(transferenciasRechazadas, true, 'rechazada')}
                                    </div>
                                </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </Col>
            </Row>

            <TransferenciaAprobacionModalComponent
                show={showModal}
                onHide={() => setShowModal(false)}
                transferencia={transferenciaSeleccionada}
                onAprobar={handleAprobar}
                onRechazar={handleRechazar}
            />

            <TransferenciaDetalleModalComponent
                show={showDetalleModal}
                onHide={() => setShowDetalleModal(false)}
                transferencia={transferenciaDetalle}
                tipo={tipoDetalle}
            />
        </PageLayout>
    );
}
